import PageCard from "features/shared/components/card/PageCard";
import RequirementDescriptorsCard from "features/requirements/components/RequirementDescriptorsCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { formatDate } from "features/shared/helpers/Formatters";
import React from "react";
import { useTranslation } from "react-i18next";
import RequirementFullDTO from "../dtos/RequirementFullDTO";

interface Props {
  detail: RequirementFullDTO;
}

const CrmRequirementDetailSection = ({ detail }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // helpers
  const descriptors = detail.requirementDescriptor ?? [];

  // render
  return (
    <>
      <PageCard title={tLabels("requirementInfoCard.cardTitle")} bodyClassName="pb-0">
        <div className="row no-gutters">
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.requirementNumber")} value={detail.requirementNumber ?? "-"} icon="tasks" />
          </div>
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.issueDate")} value={detail.issueDate ? formatDate(detail.issueDate) : "-"} icon="hourglass-start" />
          </div>
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.requirementType")} value={detail.requirementType?.name ?? "-"} icon="flag" />
          </div>
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.requirementCategory")} value={detail.requirementCategory?.name ?? "-"} icon="info-circle" />
          </div>
          <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.crmReference")} value={detail.idSourceRequirement ?? "-"} icon="tag" />
          </div>
        </div>
      </PageCard>
      <RenderWrapper isVisible={() => descriptors.length > 0}>
        <RequirementDescriptorsCard descriptors={descriptors} />
      </RenderWrapper>
      <RenderWrapper isVisible={() => !!detail.descriptionShort}>
        <PageCard title={tLabels("requirementDetail.descriptionTitle")} bodyClassName="pb-0">
          <div className="row no-gutters">
            <div className="col-12 px-sm-3 pb-2 pb-sm-3">
              <p className="mb-0 text-break">
                {detail.descriptionShort}
              </p>
            </div>
          </div>
        </PageCard>
      </RenderWrapper>
    </>
  );
};

export default CrmRequirementDetailSection;